// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.float-save-button[data-v-2c70c778]{\r\n    z-index:90;\r\n    position:fixed;\r\n    bottom:10%;\r\n    right:10px;\n}\r\n", ""]);
// Exports
module.exports = exports;
